<template>
  <CollapsePanel class="authentication-container" name="authentication-panel">
    <div class="title" slot="title">权限管理</div>
    <div slot="content">
      <div class="flex-row">
        <div class="caption-title">Owner:</div>
        <div class="label">
          {{ item.owner }}
        </div>
        <a
          v-if="item.isOwner"
          class="edit-owner-button"
          href="#"
          @click.prevent.stop="$emit('edit-owner')"
        >
          <Icon type="md-create" color="#1673FF" size="18" />
        </a>
      </div>
      <div
        class="flex-row"
        v-if="
          item.pendingOwner !== '0x0000000000000000000000000000000000000000'
        "
      >
        <div class="caption-title">待接受 Owner:</div>
        <div class="label">
          {{ item.pendingOwner }}
        </div>
        <Button
          v-if="myAddr === item.pendingOwner"
          type="success"
          style="margin-left: 16px"
          @click="$emit('accept-owner')"
        >
          接受成为 Owner
        </Button>
      </div>
      <AccessControl :editable="item.isOwner" :vaultAddress="item.address" />
    </div>
  </CollapsePanel>
</template>

<script>
import CollapsePanel from "../../../components/common/CollapsePanel";
import AccessControl from "../../../components/role/AccessControl";

export default {
  name: "Authentication",
  props: {
    item: {
      type: Object,
    },
  },
  components: {
    AccessControl,
    CollapsePanel,
  },
  mounted() {},
  data() {
    return {
      myAddr: window.currAddress,
    };
  },
  computed: {},
  methods: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "../../../common/fonts.scss";
@import "../../../common/colors.scss";

.flex-row {
  display: flex;
  align-items: center;
  margin: 0 0 16px 0;
}

.title {
  @include fontSize-16;
  @include mediumFont;
  color: #e6e6e6;
}

.caption-title {
  @include fontSize-14;
  @include regularFont;
  color: rgba(#8f92a1, 0.5);
  margin: 0 12px 0 0;
}

.content {
}

.label {
  background: #202125;
  border-radius: 8px;
  padding: 4px 16px;

  @include fontSize-14;
  @include regularFont;
  color: #8f92a1;
}

.edit-owner-button {
  margin: 0 0 0 12px;
}
</style>
